import { VALOR_FORBIDDEN_LOG_DATA_KEYS } from './valor/valor-logging.types';

export const CLOVER_FORBIDDEN_LOG_DATA_KEYS = [
    'accessToken',
    'apiAccessToken',
    'bearerToken',
    'cardNumber',
    'cardToken',
    'cvv2',
    'expirationDate',
    'expiryDate',
    'expiryMonth',
    'expiryYear',
    'expMonth',
    'expYear',
    'first6',
    'gatewayToken',
    'maskedPan',
    'securityCode',
] as const;

export const IPG_FORBIDDEN_LOG_DATA_KEYS = [
    ...CLOVER_FORBIDDEN_LOG_DATA_KEYS,
    ...VALOR_FORBIDDEN_LOG_DATA_KEYS,
] as const;

export type IpgForbiddenLogDataKey = (typeof IPG_FORBIDDEN_LOG_DATA_KEYS)[number];
